export default function mapToList(map, valueOnly) {
	return Array.from(map).map(([ key, value ]) => {
		return valueOnly ? value : { key, value };
	});
}
